import { useLayoutEffect } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Tab from "./Tab"
import useTrapFocus from "./useTrapFocus"

function TabList(props) {
  const {
    name,
    children,
    accessibilityDescription,
    onChange = _.noop,
    onTrackEvent = _.noop,
    tabs = []
  } = props
  const [tablistRef, handleKeyDown] = useTrapFocus(null)

  useLayoutEffect(() => {
    if (tablistRef.current) {
      const tabListOverflow = tablistRef.current.firstChild
      const tabListButton = _.find(tabListOverflow.children, c => c.getAttribute("aria-selected"))

      if (tabListButton) {
        tabListButton.scrollIntoView({ block: "nearest", inline: "center" })
      }
    }
  }, [children, tablistRef])

  const handleClick = e => {
    onChange(e.currentTarget.value)
    onTrackEvent(e.currentTarget.value)
  }

  return (
    <div
      ref={tablistRef}
      role="tablist"
      className={classNames("oj-tab-list", name)}
      aria-label={accessibilityDescription}
    >
      <div className="tab-list-overflow">
        {typeof children === "function"
          ? children({ handleClick, handleKeyDown })
          : tabs.map(({ label, value, selected, disabled }) => (
              <Tab
                key={value}
                name={name}
                disabled={disabled}
                selected={selected}
                value={value}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
              >
                {label}
              </Tab>
            ))}
      </div>
    </div>
  )
}

TabList.propTypes = {
  accessibilityDescription: PropTypes.string,
  children: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onTrackEvent: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node,
      selected: PropTypes.bool
    })
  )
}

export default TabList
